import React from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
export const RemoveFileModal = observer(_ref => {
  let trigger = _ref.trigger,
    callback = _ref.callback;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noPadding: true,
    trigger: trigger,
    title: t('Do you want to remove file?'),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: callback,
      'custom-attribute': '360-RemoveFileModal'
    }, t('buttons.confirm'))
  });
});